import { render } from "./Trazabilidad.vue?vue&type=template&id=65acacf2&scoped=true"
import script from "./Trazabilidad.vue?vue&type=script&lang=js"
export * from "./Trazabilidad.vue?vue&type=script&lang=js"

import "./Trazabilidad.vue?vue&type=style&index=0&id=65acacf2&lang=scss&scoped=true"

import exportComponent from "E:\\laragon\\www\\proyectos\\laravel\\sandy_laravel_vue\\filtros_frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65acacf2"]])

export default __exports__